function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Webhook_svg__31_a"
}, React.createElement("stop", {
  stopColor: "#7793FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#D576F0",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 12.019v2.512a4 4 0 104.3 2.72h7.034A2.499 2.499 0 0122 18.5a2.5 2.5 0 01-4.665 1.25H12.88A6.5 6.5 0 116 12.019zM13 5a2.5 2.5 0 012.215 3.66l2.137 3.703a6.5 6.5 0 11-3.275 9.722l2.171-1.255a4 4 0 10.228-4.949l-1.294-2.24a6.51 6.51 0 01.014-.012L13.1 9.999A2.5 2.5 0 1113 5zm0-4a6.5 6.5 0 016.15 8.61l-2.234-1.29a4 4 0 10-4.824 3.077l-1.284 2.224h-.002L8.688 17.29A2.5 2.5 0 116.5 16l.045.001 2.115-3.662A6.5 6.5 0 0113 1z",
  fill: "url(#Webhook_svg__31_a)"
});

var SvgWebhook = function SvgWebhook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _ref, _ref2);
};

export default SvgWebhook;